'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = init;
function init() {
    if (typeof window.svg4everybody !== 'undefined') {
        window.svg4everybody();
    }

    // matches polyfill
    window.Element && function (ElementPrototype) {
        ElementPrototype.matches = ElementPrototype.matches || ElementPrototype.matchesSelector || ElementPrototype.webkitMatchesSelector || ElementPrototype.msMatchesSelector || function (selector) {
            var node = this;
            var nodes = (node.parentNode || node.document).querySelectorAll(selector);
            var i = -1;
            while (nodes[++i] && nodes[i] !== node) {}
            return !!nodes[i];
        };
    }(Element.prototype);

    // closest polyfill
    window.Element && function (ElementPrototype) {
        ElementPrototype.closest = ElementPrototype.closest || function (selector) {
            var el = this;
            while (el.matches && !el.matches(selector)) {
                el = el.parentNode;
            }
            return el.matches ? el : null;
        };
    }(Element.prototype);

    // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
    window.Element && function (arr) {
        arr.forEach(function (item) {
            if (item.hasOwnProperty('remove')) {
                return;
            }

            Object.defineProperty(item, 'remove', {
                configurable: true,
                enumerable: true,
                writable: true,
                value: function remove() {
                    if (this.parentNode !== null) {
                        this.parentNode.removeChild(this);
                    }
                }
            });
        });
    }([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/util/polyfills.js
// module id = ./resources/assets/js/src/util/polyfills.js
// module chunks = 0